import { render, staticRenderFns } from "./image-slider.vue?vue&type=template&id=cff10a66&"
import script from "./image-slider.vue?vue&type=script&lang=js&"
export * from "./image-slider.vue?vue&type=script&lang=js&"
import style0 from "./image-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff10a66')) {
      api.createRecord('cff10a66', component.options)
    } else {
      api.reload('cff10a66', component.options)
    }
    module.hot.accept("./image-slider.vue?vue&type=template&id=cff10a66&", function () {
      api.rerender('cff10a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/finishes-detail/components/image-slider.vue"
export default component.exports